import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_BENEFICIARY_SURVEYS_REQUEST =
  "FETCH_BENEFICIARY_SURVEYS_REQUEST";
export const FETCH_BENEFICIARY_SURVEYS_SUCCESS =
  "FETCH_BENEFICIARY_SURVEYS_SUCCESS";
export const FETCH_BENEFICIARY_SURVEYS_FAILURE =
  "FETCH_BENEFICIARY_SURVEYS_FAILURE";

export const fetchBeneficiarySurveys =
  (page = 1, limit = 10, filters = {}) =>
  async (dispatch) => {
    dispatch({ type: FETCH_BENEFICIARY_SURVEYS_REQUEST });

    const token = localStorage.getItem("token");

    try {
      let queryParams = `?page=${page}&limit=${limit}`;

      if (filters.district_id) {
        queryParams += `&district_id=${filters.district_id}`;
      }

      if (filters.municipality_id) {
        queryParams += `&municipality_id=${filters.municipality_id}`;
      }
      if (filters.ward_name) {
        queryParams += `&ward=${filters.ward_name}`;
      }

      if (filters.search) {
        queryParams += `&search=${encodeURIComponent(filters.search)}`;
      }

      if (filters.eligibility_status) {
        queryParams += `&eligibility_status=${filters.eligibility_status}`;
      }

      const response = await axios.get(
        `${BASE_URL}/v1/api/admin/beneficiary-surveys${queryParams}`,
        {
          headers: { authorization: token },
        },
      );

      if (response.data.meta.status) {
        dispatch({
          type: FETCH_BENEFICIARY_SURVEYS_SUCCESS,
          payload: {
            data: response.data.data,
            pagination: response.data.meta.pagination,
          },
        });
        return response.data;
      } else {
        dispatch({ type: FETCH_BENEFICIARY_SURVEYS_FAILURE });
        throw new Error(response.data.meta.message);
      }
    } catch (error) {
      dispatch({ type: FETCH_BENEFICIARY_SURVEYS_FAILURE });
      toast.error(
        error.response?.data?.meta?.message ||
          "Failed to fetch beneficiary surveys",
      );
      throw error;
    }
  };

//for bulk

export const fetchAllBeneficiarySurveys = async (
  filters = {},
  limit = 200000,
) => {
  const token = localStorage.getItem("token");

  let queryParams = `?page=1&limit=${limit}`;

  if (filters.district_id) {
    queryParams += `&district_id=${filters.district_id}`;
  }

  if (filters.municipality_id) {
    queryParams += `&municipality_id=${filters.municipality_id}`;
  }
  if (filters.ward_name) {
    queryParams += `&ward=${filters.ward_name}`;
  }

  if (filters.search) {
    queryParams += `&search=${encodeURIComponent(filters.search)}`;
  }

  if (filters.eligibility_status) {
    queryParams += `&eligibility_status=${filters.eligibility_status}`;
  }

  const response = await axios.get(
    `${BASE_URL}/v1/api/admin/beneficiary-surveys${queryParams}`,
    {
      headers: {
        authorization: token,
      },
    },
  );

  return response.data.data;
};
